import { IUtilityTrayOptions, PRODUCT_KEY } from "@opengov/components-nav-bar";
import { IntlShape } from "react-intl";
import { OgAssistSearchDialogProps } from "../../OgAssistSearchDialog";
import { GlobalNavApplicationId } from "../types";
import { getHelpOptions } from "./helpOptionsUtils";
import { User, getProfileSettingsOptions } from "./profileSettingsOptionsUtils";
import { getSettingsOptions } from "./settingsOptionsUtils";
import { getNotificationsOptions } from "./getNotificationsOptions";

export type GetUtilityTrayOptionsParams = {
  activeAppKey: GlobalNavApplicationId;
  activeProductKey: PRODUCT_KEY | undefined;
  entitySubdomain: string;
  user: User;
  handleSignOut: () => void;
  intl: IntlShape;
  notificationsConfig: { count: number } | undefined;
  ogAssistSearchProps?: Omit<OgAssistSearchDialogProps, "open" | "onClose">;
  handleSearchIconClick: () => void;
  handleNotificationIconClick: () => void;
  createNewActionOptions: IUtilityTrayOptions["createNewActionOptions"];
};

export function getUtilityTrayOptions({
  activeAppKey,
  activeProductKey,
  entitySubdomain,
  user,
  handleSignOut,
  intl,
  ogAssistSearchProps,
  handleSearchIconClick,
  handleNotificationIconClick,
  createNewActionOptions,
  notificationsConfig,
}: GetUtilityTrayOptionsParams): IUtilityTrayOptions {
  if (activeAppKey === "performancePublicServicePlatform") {
    return {
      profileSettingsOptions: {},
      createNewActionOptions,
    };
  }

  const baseOptions = {
    profileSettingsOptions: getProfileSettingsOptions({ entitySubdomain, user, handleSignOut }),
    helpOptions: getHelpOptions({ activeProductKey, intl }),
    ...(!!notificationsConfig && {
      notificationsOptions: getNotificationsOptions(notificationsConfig.count, handleNotificationIconClick),
    }),
  };

  if (activeAppKey === "reportsPublicServicePlatform") {
    return baseOptions;
  }

  return {
    ...baseOptions,
    ...(ogAssistSearchProps
      ? {
          searchOptions: {
            handleSearchIconClick,
          },
        }
      : {}),
    settingsOptions: getSettingsOptions({ entitySubdomain }),
    createNewActionOptions,
  };
}
